import { Filter } from "@/data/filters.constants";
import Searchbar from "@/components/pages/home/components/searchbar/searchbar";
import $filters from "@/data/filters.constants";

export interface DefaultTopBarProps {
  handleGenderSelect: (gender?: Filter | undefined) => void;
  handleFilterSelect: (selectedFilter: Filter) => void;
  handleSearch: (value: string) => void;
  scrollY: number;
}

const DefaultTopBar = ({
  handleGenderSelect,
  handleFilterSelect,
  handleSearch,
  scrollY,
}: DefaultTopBarProps) => {
  return (
    <Searchbar
      onSelectGender={handleGenderSelect}
      onSelectFilter={handleFilterSelect}
      onSearch={handleSearch}
      filters={$filters.modelFilters}
      scrollY={scrollY}
    />
  );
};

export default DefaultTopBar;
